import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-input-control',
  templateUrl: './input-control.component.html'
})
export class InputControlComponent implements OnChanges {
  @Input() fieldControl;
  @Input() form;
  @Input() type;
  @Input() isBundle?: boolean;
  @Output() controlReady = new EventEmitter<boolean>();
  constructor() {}

  /**
   * A callback method that is invoked if any data-bound properties change
   */
  ngOnChanges() {
    this.notifyControlLoadComplete();
  }

  /**
   * This method will notify when control is ready
   */
  private notifyControlLoadComplete() {
    this.controlReady.emit(true);
  }

  /**
   * getter function to check mandatory fields
   */
  get isMandatory(): boolean {
    try {
      return this.fieldControl.validations.mandatory.value;
    } catch (error) {
      return false;
    }
  }

  /**
   * this funtion is used to remove the leading and trailing space
   */
  trimValue() {
    const existingErrors = this.form.get(this.fieldControl.logicalName).errors;

    const value = this.form.get(this.fieldControl.logicalName).value.replace(/^\s+|\s+$/g, '');
    this.form.get(this.fieldControl.logicalName).setValue(value);
    this.form.get(this.fieldControl.logicalName).setErrors(existingErrors);
  }
}
